// Theme registry. Adding a new design theme later is a drop-in:
//   1) add an entry here, 2) add matching [data-theme="id"] blocks in themes.css.
export const THEMES = [
  {
    id: "leetcode",
    label: "LeetCode",
    // Which color modes this theme supports.
    modes: ["dark", "light"],
  },
];

export const DEFAULT_THEME = "leetcode";
export const DEFAULT_MODE = "dark";

export const getTheme = (id) =>
  THEMES.find((t) => t.id === id) || THEMES[0];
